import {
  DeviceAssociationGetAllResponse,
  DeviceAssociationSearchParams,
  DeviceAssociationWithId,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class DeviceAssociationApi {
  public async getDeviceAssociations(
    params: DeviceAssociationSearchParams
  ): Promise<DeviceAssociationGetAllResponse> {
    return await trpc.client.device.usage.getAll.query(params);
  }

  public async createDeviceAssociation(
    device: string,
    patient: string
  ): Promise<DeviceAssociationWithId> {
    return await trpc.client.device.usage.create.mutate({
      device,
      patient,
    });
  }

  public terminateDeviceUseStatement = async (id: string): Promise<void> => {
    await trpc.client.device.usage.terminate.mutate({ id });
  };

  public cancelDeviceUseStatement = async (id: string): Promise<void> => {
    await trpc.client.device.usage.cancel.mutate({ id });
  };
}
